import { render, staticRenderFns } from "./LastAos.vue?vue&type=template&id=20170fb0&"
import script from "./LastAos.vue?vue&type=script&lang=js&"
export * from "./LastAos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports